<script lang="ts">
import { useConfigAssistant } from '$lib/components/config-assistant/assistant-context';

const { width: assistantWidth } = useConfigAssistant();
</script>

<div
  class={[
    // overflow-y-auto: list pages (fleet, fragments) scroll here. Machine tabs with
    // h-full children (e.g. locked PageWithSidebar) still fill this pane and scroll internally.
    'page-root flex h-full min-h-0 flex-1 flex-col overflow-y-auto transition-[padding] duration-150',
    $assistantWidth > 0 && 'page-root--assistant-open',
  ]}
  style={$assistantWidth > 0
    ? `--assistant-padding: ${$assistantWidth}px`
    : undefined}
>
  <slot />
</div>

<style>
@media (min-width: 640px) {
  .page-root--assistant-open {
    padding-right: var(--assistant-padding);
  }
}
</style>
